import { ModifySettingsButton } from "../../../forms/improved_components/base_components/modify_settings_button";

export function GuildSyncsButton(props: { onClick: () => void }) {
	return (
		<ModifySettingsButton className="mr-auto mt-4" onClick={props.onClick}>
			(Admin) Manage all server syncs
		</ModifySettingsButton>
	);
}
